import { Model } from 'modules/core/lib/mobx-rest'

interface ILog {
  id: number
  document_id: number
  log_type: string
  payload: { [key: string]: string | number }
  created_at: string
}

class Log extends Model<ILog> {
  static urlRoot() {
    return '/document_logs'
  }
}

export default Log
